import React, { useState, useEffect } from 'react';
import { Container, ListGroup, Badge, Form, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import api from '../services/api';

const Notices = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    loadNotices();
  }, [filter]);

  const loadNotices = async () => {
    try {
      const params = filter ? { type: filter } : {};
      const response = await api.get('/notices/', { params });
      setNotices(response.data.results || response.data);
    } catch (error) {
      console.error('Error loading notices:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <h1 className="page-title mb-4">Notices & Announcements</h1>
      
      <Row className="mb-4">
        <Col md={4}>
          <Form.Select value={filter} onChange={(e) => setFilter(e.target.value)}>
            <option value="">All Notices</option>
            <option value="general">General</option>
            <option value="tender">Tender</option>
            <option value="recruitment">Recruitment</option>
            <option value="event">Event</option>
            <option value="public_notice">Public Notice</option>
          </Form.Select>
        </Col>
      </Row>

      <ListGroup>
        {notices.map(notice => (
          <ListGroup.Item key={notice.id} className="mb-3">
            <div className="d-flex justify-content-between align-items-start">
              <div className="flex-grow-1">
                <h5>
                  <Link to={`/notices/${notice.slug}`}>{notice.title}</Link>
                </h5>
                <div className="mb-2">
                  <Badge bg="primary" className="me-2">{notice.notice_type}</Badge>
                  {notice.is_new && <Badge bg="danger" className="me-2">New</Badge>}
                  <span className="text-muted small">
                    Published: {moment(notice.published_date).format('MMM DD, YYYY')}
                  </span>
                  {notice.expiry_date && (
                    <span className="text-muted small ms-3">
                      Expires: {moment(notice.expiry_date).format('MMM DD, YYYY')}
                    </span>
                  )}
                </div>
                <div dangerouslySetInnerHTML={{ __html: notice.description.substring(0, 200) }} />
              </div>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Container>
  );
};

export default Notices;
